export const CONVERSATION_AVATAR_MAP: Record<number, string> = {
  1: './assets/users/chicken.svg',
  2: './assets/users/clownfish.svg',
  3: './assets/users/duck.svg',
  4: './assets/users/frog.svg',
  5: './assets/users/goldfish.svg',
  6: './assets/users/rabbit.svg',
  7: './assets/users/shark.svg',
  8: './assets/users/spider.svg',
  9: './assets/users/stork.svg',
  10: './assets/users/toucan.svg'
};

export const CONVERSATION_AVATAR_COLORS_DARK: Record<number, { background: string; color: string }> = {
  1:  { background: '#1E293B', color: '#F87171' },
  2:  { background: '#0F172A', color: '#38BDF8' },
  3:  { background: '#052E16', color: '#4ADE80' },
  4:  { background: '#2B1C0F', color: '#FB923C' },
  5:  { background: '#2E1065', color: '#A78BFA' },
  6:  { background: '#3F0D24', color: '#F472B6' },
  7:  { background: '#082F49', color: '#7DD3FC' },
  8:  { background: '#1F2937', color: '#E879F9' },
  9:  { background: '#1C1917', color: '#FACC15' },
  10: { background: '#111827', color: '#34D399' }
};


export const CONVERSATION_AVATAR_COLORS: Record<number, { background: string; color: string }> = {
  1:  { background: 'linear-gradient(135deg, #fee2e2 0%, #fca5a5 100%)', color: '#991b1b' },
  2:  { background: 'linear-gradient(135deg, #dbeafe 0%, #93c5fd 100%)', color: '#1e40af' },
  3:  { background: 'linear-gradient(135deg, #d1fae5 0%, #6ee7b7 100%)', color: '#065f46' },
  4:  { background: 'linear-gradient(135deg, #ffedd5 0%, #fdba74 100%)', color: '#9a3412' },
  5:  { background: 'linear-gradient(135deg, #ede9fe 0%, #c4b5fd 100%)', color: '#4c1d95' },
  6:  { background: 'linear-gradient(135deg, #fce7f3 0%, #f9a8d4 100%)', color: '#9d174d' },
  7:  { background: 'linear-gradient(135deg, #e0f7ff 0%, #7dd3fc 100%)', color: '#0c4a6e' },
  8:  { background: 'linear-gradient(135deg, #f3e8ff 0%, #d8b4fe 100%)', color: '#5b21b6' },
  9:  { background: 'linear-gradient(135deg, #fef9c3 0%, #fde047 100%)', color: '#854d0e' },
  10: { background: 'linear-gradient(135deg, #ffe4e6 0%, #fda4af 100%)', color: '#7f1d1d' },
};


